<template>
  <div>
    <div class="bg-light-gray rounded-bottom p-2">
      <div class="bg-white rounded pt-4 px-5">
        <p class="font-16 mb-3">
          <i class="font-20 fas fa-tag mr-2 text-orange"></i>
          Etiquetar informe
        </p>

        <div class="row">
          <div class="col-12 d-flex justify-content-between">
            <autocomplete-and-create
              ref="autocompleteTagsRef"
              :suggestions="tagOptions"
              v-model="currentTag"
              @on-delete="deleteOption"
              can-remove
            />
            <action-button
              @click="addTags"
              i="fas fa-file-plus"
              variant="success"
              id="btn-search"
              text="Añadir"
              class="ml-3"
            />
          </div>
          <div class="col-12 pl-2" :class="!listOfTags.length && 'mb-5'">
            <custom-chips-group
              v-if="listOfTags.length"
              class="text-left chips-group_extended"
              no-background
              no-wrap
              object-sub-title="name"
              @itemMarkedForDeletion="onItemDeletedHandler"
              :selected-items="listOfTags"
              title=""
            />
          </div>
        </div>
      </div>
      <div class="row mt-4 mb-3 px-5">
        <div class="col-12 d-flex justify-content-end">
          <action-button
            @click="$emit('close')"
            i="fas fa-times-circle"
            variant="outline-danger"
            id="btn-search"
            text="Cerrar"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { name as specialReportModuleName } from '@/modules/special-report/store'
import ActionButton from 'ActionButton'
import { CustomChipsGroup, AutocompleteAndCreate } from '@/components/common'
import SpecialService from '@/services/api/special.api'
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'
export default {
  name: 'Tags',
  components: {
    ActionButton,
    CustomChipsGroup,
    AutocompleteAndCreate,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    tags: [],
    currentTag: null,
  }),
  computed: {
    tagOptions() {
      return this.tags || []
    },
    listOfTags() {
      return this.value.tags || []
    },
  },
  mounted() {
    this.getTags()
  },
  methods: {
    ...mapActions(specialReportModuleName, ['setTagsCounter']),
    async getTags() {
      const { data } = await SpecialService.getTags().catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error')
      })
      this.setTagsCounter(data.length)
      this.tags = data.filter(
        (el) =>
          !this.listOfTags.find(
            (rm) => rm.name.toLowerCase() === el.name.toLowerCase()
          )
      )
    },
    async addTags() {
      const { data } = await SpecialService.addTag(
        this.value.id,
        this.currentTag.name
      ).catch((err) => {
        this.$refs.autocompleteTagsRef?.onClearHandler()
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error')
      })
      if (data) {
        this.$refs.autocompleteTagsRef?.onClearHandler()
        this.$emit('load-tags')
        setTimeout(() => {
          this.getTags()
        }, 500)
      }
    },
    async onItemDeletedHandler(item) {
      const { data } = await SpecialService.removeTag(
        this.value.id,
        item.tagId
      ).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error')
      })
      if (data) {
        this.$emit('load-tags')
        setTimeout(() => {
          this.getTags()
        }, 500)
      }
    },
    async deleteOption(opt) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover la etiqueta "${opt.name}" del listado?`,
        'Sí',
        'No'
      )

      if (!answer) return

      const { data } = await SpecialService.inactivateTag(opt.id).catch(
        (err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          )
        }
      )

      if (data) {
        this.ShowToast(
          'Proceso Exitoso',
          'Se ha removido la etiqueta exitosamente.',
          'success'
        )
        this.$emit('load-tags')
        setTimeout(() => {
          this.getTags()
        }, 500)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chips-group_extended {
  margin-top: -0.5rem;

  ::v-deep {
    .chips-container {
      margin: 0 !important;
      padding-top: 0 !important;

      p.bold {
        font-weight: normal !important;
      }
    }
  }
}
</style>
